"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// MIT © 2017 azu
var hasOwn = Object.prototype.hasOwnProperty;
// Object.is ponyfill
exports.is = function (x, y) {
    if (x === y) {
        return x !== 0 || y !== 0 || 1 / x === 1 / y;
    }
    else {
        return x !== x && y !== y;
    }
};
exports.shallowEqual = function (objA, objB) {
    if (objA === objB) {
        return true;
    }
    if (typeof objA !== "object" || objA === null ||
        typeof objB !== "object" || objB === null) {
        return false;
    }
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) {
        return false;
    }
    for (var i = 0; i < keysA.length; i++) {
        if (!hasOwn.call(objB, keysA[i]) || !exports.is(objA[keysA[i]], objB[keysA[i]])) {
            return false;
        }
    }
    return true;
};
//# sourceMappingURL=shallow-equal-object.js.map


//////////////////
// WEBPACK FOOTER
// ./~/shallow-equal-object/lib/src/shallow-equal-object.js
// module id = 225
// module chunks = 0